import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const MAINTENANCE_CATEGORIES_MAINTENANCE_CATEGORY_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/maintenance-categories',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:MaintenanceCategories',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.MaintenanceCategories',
      },
    ]);
  };
}
